/**
 * 行为埋点 SDK - 属性脱敏
 * 移除敏感 key，截断超长值，防止 PII 上报
 */

/** 禁止上报的敏感 key（大小写不敏感匹配） */
const SENSITIVE_KEYS = new Set([
  'token',
  'password',
  'secret',
  'authorization',
  'cookie',
  'access_token',
  'refresh_token',
  'api_key',
  'private_key',
]);

/** 单个属性值最大长度 */
const MAX_VALUE_LENGTH = 500;

/** 最多允许的属性 key 数 */
const MAX_PROPS_COUNT = 30;

function isSensitiveKey(key: string): boolean {
  const lower = key.toLowerCase();
  return SENSITIVE_KEYS.has(lower) || lower.includes('token') || lower.includes('secret');
}

function truncateValue(value: unknown): unknown {
  if (typeof value === 'string' && value.length > MAX_VALUE_LENGTH) {
    return value.slice(0, MAX_VALUE_LENGTH);
  }
  return value;
}

/** 对事件属性做脱敏处理 */
export function sanitizeProperties(props: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  let count = 0;

  for (const [key, value] of Object.entries(props)) {
    if (count >= MAX_PROPS_COUNT) break;
    if (isSensitiveKey(key)) continue;

    result[key] = truncateValue(value);
    count++;
  }

  return result;
}
